import Careers from 'fitify-ui-landing/src/components/blocks/Careers/Careers'
import { StyledContainer } from 'fitify-ui-landing/src/components/blocks/Careers/Careers.Styled'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Layout from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const CareersPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: t('landing_careers') + ' | Fitify',
        description: t('landing_carrers_meta_description'),
      }}
    >
      <Section>
        <StyledContainer>
          <Careers />
        </StyledContainer>
      </Section>
    </Layout>
  )
}

export default CareersPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
